import {
  FilterModel,
  FilterModelWithKeys,
} from '@features/vt-grid/interfaces/grid-context';
import { TripType } from '@pages/trips-page/constants';
import DateUtils from '@shared/utils/date.utils';
import TripTypeUtils from '@shared/utils/trip-type.utils';

export default class CustomGridFilterUtils {
  static getStartTimeCustomPeriodFilters(
    startDate: Date,
    endDate: Date,
    isCustomDateSelected = false
  ): FilterModelWithKeys {
    const end = new Date(endDate);
    end.setDate(endDate.getDate() + 1);
    return {
      StartTime: {
        filterType: 'date',
        operator: 'AND',
        conditions: [
          {
            dateFrom: `${DateUtils.convertDate(startDate)} 00:00:00`,
            dateTo: null,
            filterType: 'date',
            type: 'greaterThan',
          },
          {
            dateFrom: `${DateUtils.convertDate(
              isCustomDateSelected ? end : endDate
            )} 00:00:00`,
            dateTo: null,
            filterType: 'date',
            type: 'lessThan',
          },
        ],
      } as FilterModel,
    };
  }

  static getCorporateTripTypeFilter(): FilterModelWithKeys {
    return {
      TripTypeID: {
        filterType: 'number',
        type: 'equals',
        filter: TripTypeUtils.getTripTypeId(TripType.Corporate),
      },
    };
  }
}
